<template>
  <CommonModal>
    <template slot="header">
      <h3>Add Exhaust Certification</h3>
    </template>
    <template slot="body">
      <div style="overflow: auto; height: 450px">
        <table class="write_tbl">
          <tbody>
            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="form.exhaustCertiVO.exhaustCertiName"
                  v-validate="'required'"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="form.exhaustCertiVO.exhaustCertiDesc"
                ></textarea>
              </td>
            </tr>
            <tr>
              <th>사용여부</th>
              <td>
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="form.exhaustCertiVO.useYn"
                    value="Y"
                  />
                  Use</label
                >
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="form.exhaustCertiVO.useYn"
                    value="N"
                  />
                  Unused</label
                >
              </td>
            </tr>
          </tbody>
        </table>

        <!-- <table class="write_tbl" v-for="(item, index) in form.languages" :key="index">
          <tbody>
            <tr>
              <th>언어</th>
              <td>
                {{ item.language.codeName }}
              </td>
            </tr>
            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="item.name"
                  v-validate="item.language.codeId == 'en' ? 'required' : ''"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="item.desc"
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table> -->
      </div>
    </template>
    <template slot="footer">
      <slot name="footer"> </slot>
    </template>
  </CommonModal>
</template>

<script>
import CommonModal from "@/components/modal/CommonModal";
import {
  fetchExCertificationForm,
  addExCertification,
  checkExhaustDuplication,
} from "@/api/exhaustcerti";

export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      form: {
        exhaustCertiVO: {
          exhaustCertiId: "",
          exhaustCertiName: "",
          exhaustCertiDesc: "",
          useYn: "",
        },

        languages: [],
      },
      exhaustcerti: "",
    };
  },
  methods: {
    async save() {
      const validForm = await this.$validator.validateAll();
      if (validForm) {
        //ExhaustCertiName 중복확인
        const { data } = await checkExhaustDuplication(this.form);
        this.exhaustcerti = data.exhaustcerti;
        if (
          this.exhaustcerti == null ||
          this.exhaustcerti == "" ||
          this.exhaustcerti.length == 0
        ) {
          try {
            const response = await addExCertification(this.form);
            return response.data.status;
            // if (response.data.status) {
            //   this.reset();
            // }
          } catch (error) {
            console.log(error);
          }
        } else {
          return "alert.alreadyExist";
          // alert(this.$t("alert.alreadyExist"));
        }
      } else {
        return "alert.plzCheckAllValues";
        // alert(this.$t("alert.plzCheckAllValues"));
      }
    },
    reset() {
      this.form.exhaustCertiVO.exhaustCertiId = "";
      this.form.exhaustCertiVO.exhaustCertiName = "";
      this.form.exhaustCertiVO.exhaustCertiDesc = "";
      this.form.exhaustCertiVO.useYn = "Y";
    },
    async fetchProdTypeForm(upperId, level) {
      const response = await fetchExCertificationForm(upperId, level);
      console.log(response);
      this.form = response.data;
      this.form.exhaustCertiVO.useYn = "Y";
    },
  },
};
</script>

<style></style>
